/**
 * Appends a segment to a given path
 * @param basePath - The base path to append to
 * @param nextPage - The segment to append
 * @returns The combined path
 */
export const appendToPath = (basePath: string, nextPage: string): string => {
  return basePath + "/" + nextPage;
};

/**
 * Removes the last segment from a path
 * @param path - The path to modify
 * @returns The path with the last segment removed
 */
export const goBackOneLevel = (path: string, level: number = 1): string => {
  return path.split("/").slice(0, -level).join("/");
};

/**
 * Custom hook to create a path appender function for the current location
 * Must be used inside a React component
 */
export const usePathAppender = () => {
  // This should be used inside a component that has access to the router context
  const getCurrentPath = () => window.location.pathname;

  return {
    appendToCurrentPath: (nextPage: string): string => {
      return appendToPath(getCurrentPath(), nextPage);
    },
    goBackFromCurrentPath: (): string => {
      return goBackOneLevel(getCurrentPath());
    },
  };
};
